import { Bot } from "lucide-react";

export default function AiCta({ label = "Ask IndiaFast Assistant", action = null, testid = "ai-cta-btn", className = "" }) {
  return (
    <button type="button" data-testid={testid}
            onClick={() => window.dispatchEvent(new CustomEvent("if-ai:open", { detail: { action } }))}
            className={`inline-flex items-center gap-2 rounded-full border border-saffron/40 bg-saffron/10 px-5 py-2.5 text-sm font-bold text-saffron transition-colors hover:bg-saffron hover:text-white ${className}`}>
      <Bot className="h-4 w-4" /> {label}
    </button>
  );
}
